module.exports = __webpack_public_path__ + "static/media/kreditu-centras.82c51fbe.png";